import type { GetAuthTokenCache } from '../cache';
import { TeamsAuthenticator } from '../teams';
import { AuthenticatorType } from '../types';

import { getAuthToken } from './getAuthToken';

// This authenticator supports skypetoken when anonymous users join a meeting.
// The authenticator is identified as a different type as it cannot support certain authentication flows like
// getting an image rendering cookie.
export default class TeamsMeetingAuthenticator extends TeamsAuthenticator {
  public readonly type = AuthenticatorType.TeamsMeeting;
  protected readonly isAnonymousAuth: boolean = false;

  constructor(getAuthTokenCache: GetAuthTokenCache, isAnonymousAuth = false) {
    super(getAuthTokenCache);
    this.isAnonymousAuth = isAnonymousAuth;
  }

  public getToken = (resource: string, claims?: string[]): Promise<string> =>
    getAuthToken(resource, this.isAnonymousAuth, claims);
}
